import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "./contexts/AuthContext";
import React from "react";
import { RecoilRoot } from "recoil";
import Routes from "./routes";

const queryClient = new QueryClient()


function App() {

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RecoilRoot>
            <Routes />
          </RecoilRoot>
        </AuthProvider>
      </QueryClientProvider >

    </>
  );
}

export default App
